import {Modal} from "antd";
import {Link} from "react-router-dom";
import React from "react";

function ToRoman(num) {
    let lookup = {M: 1000, CM: 900, D: 500, CD: 400, C: 100, XC: 90, L: 50, XL: 40, X: 10, IX: 9, V: 5, IV: 4, I: 1}, roman = '', i;
    for (i in lookup) {
        while (num >= lookup[i]) {
            roman += i;
            num -= lookup[i];
        }
    }
    return roman;
}

const syllabusData = []
for (let i = 6; i <= 10; i++) {
    syllabusData.push({
        class: ToRoman(i),
        link: `class${i}_syllabus`
    })
}
export const partnerData = [
    {
        class: "Darbhanga",
        link: `/our_branches/darbhanga`
    },
    {
        class: "Saharanpur",
        link: `/our_branches/saharanpur`
    },
    {
        class: "Meerut",
        link: `/our_branches/meerut`
    }
]

export {syllabusData};
